import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { WaveAvatar } from "./WaveAvatar";
import type { WaveTooltipPlacement } from "./WaveTooltip";
import { WaveTooltip } from "./WaveTooltip";
import type { MinimalWave } from "@/contexts/wave/hooks/useEnhancedWavesListCore";
interface CollapsedWaveProps {
  readonly formattedWaveName: string;
  readonly haveNewDrops: boolean;
  readonly href: string;
  readonly isActive: boolean;
  readonly isDropWave: boolean;
  readonly onMouseEnter?: (() => void) | undefined;
  readonly onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  readonly showTooltip: boolean;
  readonly tooltipId: string;
  readonly tooltipPlacement: WaveTooltipPlacement;
  readonly wave: MinimalWave;
}
export const CollapsedWave = t0 => {
  const $ = _c(25);
  const {
    formattedWaveName,
    haveNewDrops,
    href,
    isActive,
    isDropWave,
    onMouseEnter,
    onClick,
    showTooltip,
    tooltipId,
    tooltipPlacement,
    wave
  } = t0;
  const t1 = `tw-group tw-flex tw-items-center tw-justify-center tw-py-2 tw-transition-all tw-duration-200 tw-ease-out ${isActive ? "tw-bg-iron-700/60 desktop-hover:hover:tw-bg-iron-700/70" : "desktop-hover:hover:tw-bg-iron-800/70"}`;
  let t2;
  if ($[0] !== onMouseEnter) {
    t2 = onMouseEnter ? {
      onMouseEnter
    } : {};
    $[0] = onMouseEnter;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== showTooltip || $[3] !== tooltipId) {
    t3 = showTooltip ? {
      "data-tooltip-id": tooltipId
    } : {};
    $[2] = showTooltip;
    $[3] = tooltipId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !isActive && haveNewDrops;
  let t5;
  if ($[5] !== isActive || $[6] !== isDropWave || $[7] !== t4 || $[8] !== wave) {
    t5 = <div className="tw-relative"><WaveAvatar isActive={isActive} isDropWave={isDropWave} showNewDropsBadge={t4} wave={wave} /></div>;
    $[5] = isActive;
    $[6] = isDropWave;
    $[7] = t4;
    $[8] = wave;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== href || $[11] !== onClick || $[12] !== t2 || $[13] !== t3 || $[14] !== t5) {
    t6 = <Link href={href} prefetch={false} {...t2} onClick={onClick} className="tw-flex tw-items-center tw-justify-center tw-no-underline" {...t3}>{t5}</Link>;
    $[10] = href;
    $[11] = onClick;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== formattedWaveName || $[17] !== showTooltip || $[18] !== tooltipId || $[19] !== tooltipPlacement) {
    t7 = showTooltip && <WaveTooltip id={tooltipId} place={tooltipPlacement}>{formattedWaveName}</WaveTooltip>;
    $[16] = formattedWaveName;
    $[17] = showTooltip;
    $[18] = tooltipId;
    $[19] = tooltipPlacement;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t1 || $[22] !== t6 || $[23] !== t7) {
    t8 = <div className={t1}>{t6}{t7}</div>;
    $[21] = t1;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};